"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const common_1 = require("@Const/common");
const DashboardLatestStatementsRow = ({ payeeName, statementsLink, paymentStatus, paymentAmount, }) => (react_1.default.createElement("a", { className: 'dashboard-statement-row', role: 'link', href: statementsLink },
    react_1.default.createElement("div", { className: 'dashboard-statement-name' },
        react_1.default.createElement("div", { className: 'dashboard-payee-name' }, payeeName),
        react_1.default.createElement("img", { className: 'right-chevron', src: common_1.ICONS.chevron_right, alt: 'right chevron icon' })),
    react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'dashboard-statement-amt' }, paymentAmount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }))),
    react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'dashboard-statement-status' }, paymentStatus))));
exports.default = DashboardLatestStatementsRow;
